module.exports = __webpack_public_path__ + "static/img/ing-life-thumb.be2af67.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/ing-life-thumb.jpg
// module id = 1Boq
// module chunks = 0